/**
 * パスワードリセットサービス
 * バックエンドAPIを使用してパスワードリセット機能を提供
 */

import { authApiClient } from './authApiClient';

class PasswordResetService {
  constructor(apiClient = authApiClient) {
    this.apiClient = apiClient;
    this.isDevelopment = process.env.NODE_ENV === 'development';
  }

  /**
   * パスワードリセットメール送信
   * @param {string} email - メールアドレス
   * @returns {Promise<Object>} 実行結果
   */
  async sendPasswordResetEmail(email) {
    try {
      
      // バックエンドAPIを呼び出し
      const result = await this.apiClient.sendPasswordResetEmail(email);
      
      if (result.success) {
        return {
          success: true,
          message: result.message || 'パスワードリセット用のメールを送信しました。メールをご確認ください。',
          type: 'success'
        };
      }
      
      // API呼び出しは成功したがビジネスロジックでエラー
      return {
        success: false,
        error: result.error || 'メール送信に失敗しました',
        type: 'error'
      };
      
    } catch (error) {
      console.error('[PASSWORD RESET SERVICE] Failed to send password reset email:', error);
      
      return {
        success: false,
        error: error.message || 'パスワードリセットメールの送信に失敗しました。しばらく時間をおいてから再度お試しください。',
        type: 'api',
        originalError: error
      };
    }
  }

  /**
   * サービス情報を取得（デバッグ用）
   * @returns {Object} サービス情報
   */
  getServiceInfo() {
    return {
      isDevelopment: this.isDevelopment,
      environment: process.env.NODE_ENV,
      apiClientInfo: this.apiClient.getConfig(),
      version: '1.0.0'
    };
  }
}

// インスタンス作成関数
export const createPasswordResetService = () => {
  return new PasswordResetService();
};

// デフォルトインスタンス
export const passwordResetService = createPasswordResetService();

// 関数スタイルのエクスポート
export const sendPasswordResetEmail = (email) => 
  passwordResetService.sendPasswordResetEmail(email);

export default PasswordResetService;